import { render } from "./TaxReportCustom2023.vue?vue&type=template&id=46401f98&scoped=true"
import script from "./TaxReportCustom2023.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom2023.vue?vue&type=script&lang=js"

import "./TaxReportCustom2023.vue?vue&type=style&index=0&id=46401f98&scoped=true&lang=css"
import "./TaxReportCustom2023.vue?vue&type=style&index=1&id=46401f98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46401f98"]])

export default __exports__